export type FontWeight = 'light' | 'regular' | 'medium' | 'semibold' | 'bold' | 'heavy';

export enum MapToWeight {
  light = 300,
  regular = 400,
  medium = 500,
  semibold = 600,
  bold = 700,
  heavy = 900,
}

export interface DefaultCloseIconStyles {
  height: string;
  width: string;
}

export type TooltipPlacement =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';

export type TooltipTrigger = 'hover' | 'click' | [];

export interface DataAttributes {
  [name: string]: string | number | boolean | undefined;
}

export type AvatarVariants =
  | 'circle'
  | 'square'
  | 'rounded'
  | 'rounded-circle'
  | 'rounded-circle-text-icon';

export type TagVariants = 'dashed-capsule' | 'capsule' | 'round' | 'size-tag';

export type TagColorThemes =
  | 'primary'
  | 'alt-primary'
  | 'secondary'
  | 'success'
  | 'light-success'
  | 'warning'
  | 'alt-warning'
  | 'danger'
  | 'gray'
  | 'pink'
  | 'alt-secondary'
  | 'darkGray'
  | 'custom';

export type CardItemPlacement =
  | 'top'
  | 'bottom'
  | 'center'
  | 'left'
  | 'right'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export type TableDataValue =
  | string
  | number
  | boolean
  | Array<string | number>
  | React.ReactNode
  | React.Key
  | Record<string, string | number>;

export type PopperPlacement =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';

export type AlertsPlacement =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';
